import { createSlice } from '@reduxjs/toolkit'
import { clearSharedAuthCookies } from '../utils/crossDomainAuth'

export interface StoryQuotaValues {
  used: number
  max: number
  remaining: number
}

interface UserInfoState {
  sessionId: number | null
  accessToken: string | null
  userInfo: Record<string, unknown>
  account?: { name: string; email: string }
  storyQuota: StoryQuotaValues | null
}

const initialState: UserInfoState = {
  sessionId: null,
  accessToken: null,
  userInfo: {},
  storyQuota: null,
}

const userInfoSlice = createSlice({
  name: 'userInfo',
  initialState,
  reducers: {
    setUserInfo: (state, action) => {
      state.accessToken = action.payload.accessToken
      state.userInfo = action.payload.account ?? {}
      state.sessionId = action.payload.sessionId ?? null
      state.account = action.payload.account
    },
    setStoryQuota: (state, action) => {
      state.storyQuota = action.payload
    },
    resetUserInfo: (state) => {
      state.sessionId = null
      state.accessToken = null
      state.userInfo = {}
      state.account = undefined
      state.storyQuota = null
      localStorage.removeItem('access_token')
      localStorage.removeItem('refresh_token')
      clearSharedAuthCookies()
    },
  },
})

export const { setUserInfo, resetUserInfo, setStoryQuota } = userInfoSlice.actions
export default userInfoSlice.reducer
